const releaseFormsRouter = [
    {
        path:'',
        name:'releaseForms-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/releaseForms/index.vue'),
        children:[
            {
                path:'',
                name:'releaseForms-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視評估表單，或者新增評估表單' }
            },
            {
                path:'create',
                name:'releaseForms-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseForms/create.vue'),
            },
            {
                path:'detail/:id',
                name:'releaseForms-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseForms/detail.vue'),
            },{
                path:'edit/:id',
                name:'releaseForms-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseForms/edit.vue'),
            },
        ]
    },
  ]
  export default releaseFormsRouter

  